import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { RdSAPResultsDetailV0 } from '../../../../../models/rdsap/rdSAPResultsDetailV0';

@Component({
  selector: 'app-rdsap-summary-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss']
})
export class DetailsComponent {
  private _eeStatusDetails: RdSAPResultsDetailV0;

  constructor(private cd: ChangeDetectorRef) {}

  @Input()
  set eeStatusDetails(value: RdSAPResultsDetailV0) {
    this._eeStatusDetails = value;
    this.cd.detectChanges();
  }

  get eeStatusDetails(): RdSAPResultsDetailV0 {
    return this._eeStatusDetails;
  }

}
